document.addEventListener('DOMContentLoaded', () => {
  // Create a single overlay element
  const overlay = document.createElement('div');
  overlay.className = 'mega-menu-overlay';
  document.body.appendChild(overlay);

  let activeMegaMenu = null;
  let activeTrigger = null;

  const closeAll = () => {
    if (activeMegaMenu) {
      activeMegaMenu.classList.remove('is-open');
      overlay.classList.remove('is-open');
      activeTrigger?.classList.remove('mega-menu-active');
      activeMegaMenu = null;
      activeTrigger = null;
    }
  };

  const openMenu = (megaMenu, trigger) => {
    // If clicking the same trigger, close it
    if (activeMegaMenu === megaMenu) {
      closeAll();
      return;
    }

    closeAll();

    // Position below header
    const header = megaMenu.closest('.main-header') || megaMenu.closest('header');
    if (header) {
      megaMenu.style.top = header.getBoundingClientRect().bottom + 'px';
    }

    megaMenu.classList.add('is-open');
    overlay.classList.add('is-open');
    trigger?.classList.add('mega-menu-active');
    activeMegaMenu = megaMenu;
    activeTrigger = trigger;

    // Activate first category
    const categories = megaMenu.querySelectorAll('.mega-menu__category');
    const subpanels = megaMenu.querySelectorAll('.mega-menu__subpanel');
    if (categories.length > 0) {
      activateCategory(categories, subpanels, 0);
    }
  };

  const activateCategory = (categories, subpanels, index) => {
    categories.forEach((cat) => cat.classList.remove('is-active'));
    subpanels.forEach((panel) => panel.classList.remove('is-active'));
    categories[index]?.classList.add('is-active');
    subpanels[index]?.classList.add('is-active');
  };

  // Bind click triggers for each mega menu
  document.querySelectorAll('.mega-menu').forEach((megaMenu) => {
    const navItem = megaMenu.closest('.menu-single-row__nav-item, .menu-two-row__nav-item');
    if (!navItem) return;

    const trigger = navItem.querySelector('.menu-single-row__nav-link, .menu-two-row__nav-link');
    if (!trigger) return;

    // Prevent default navigation on click — open mega menu instead
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      openMenu(megaMenu, trigger);
    });

    // Category hover inside the panel
    const categories = megaMenu.querySelectorAll('.mega-menu__category');
    const subpanels = megaMenu.querySelectorAll('.mega-menu__subpanel');

    categories.forEach((category, index) => {
      category.addEventListener('mouseenter', () => {
        activateCategory(categories, subpanels, index);
      });
    });
  });

  // Close on overlay click
  overlay.addEventListener('click', closeAll);

  // Close on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });

  // Close when clicking outside
  document.addEventListener('click', (e) => {
    if (!activeMegaMenu) return;
    if (!e.target.closest('.mega-menu') && !e.target.closest('.mega-menu-active')) {
      closeAll();
    }
  });
});
